import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Col } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomTextArea } from '../../../../../shared/customTextArea';
import { CustomButton } from '../../../../../shared/customButton';
import styles from './createQuestions.module.scss'; // Assuming the CSS module is named 'createQuestions.module.scss'


// Define the validation schema
const schema = Yup.object({
    message: Yup.string()
        .trim()
        .matches(/^[^<>=*$^]*$/, 'Remove restricted characters such as: < > = $ * ^')
        .max(300, 'Character length should be less than 300')
        .required('Required'),
    ans_min: Yup.number()
        .required('Required')
        .min(1, 'Maximum answer duration must be within 1 - 10 mins')
        .max(10, 'Maximum answer duration must be within 1 - 10 mins'),
});

const EditQuestionModalActiveTempalte = ({ showModal, handleClose, question, index, setFieldValue }) => {
    const [message, setMessage] = useState(question?.message || '');
    const [ansMin, setAnsMin] = useState(question?.ans_min || 1);

    useEffect(() => {
        setMessage(question?.message || '');
        setAnsMin(question?.ans_min || 1);
    }, [question]);

    if (!question) {
        return null;
    }

    return (
        <Formik
            enableReinitialize
            initialValues={{
                message: message,
                ans_min: ansMin,
            }}
            validationSchema={schema}
            onSubmit={(values) => {
                setFieldValue(`questions.${index}.message`, values.message);
                setFieldValue(`questions.${index}.ans_min`, values.ans_min);
                handleClose();
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Modal show={showModal} onHide={handleClose} backdrop="static" keyboard={false} centered size="md">
                    <Modal.Body>
                        <div className={styles.modalCancelBtnDiv}>
                            <Button className={styles.modalCancelBtn} onClick={handleClose}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </Button>
                        </div>
                        <div className={styles.modalHeaderDiv}>
                            <h2 className={styles.modalHeader}>Edit Question</h2>
                        </div>
                        <Col sm={12}>
                            <Form noValidate onSubmit={handleSubmit}>
                                <Field name="ans_min">
                                    {({ field, form, meta }) => (
                                        <CustomTextField
                                            label="Maximum Answer Duration"
                                            classLabel="defaultLabel"
                                            controlId="ans_min"
                                            placeholder="Ex: 3 min"
                                            type="number"
                                            value={field.value}
                                            name={field.name}
                                            classType="defaultTextBox"
                                            handleOnChange={field.onChange}
                                            errorMessage={meta.touched && meta.error ? meta.error : ''}
                                            isInvalid={meta.touched && !!meta.error}
                                        />
                                    )}
                                </Field>
                                <Field name="message">
                                    {({ field, form, meta }) => (
                                        <Form.Group controlId={field.name}>
                                            <Form.Label><p className={styles.TextAreaTitle}>Question</p></Form.Label>
                                            <Form.Control
                                                className={styles.TextArea}
                                                as="textarea"
                                                placeholder='Ex: Please tell me about yourself and your educational background in brief.'
                                                name={field.name}
                                                value={field.value}
                                                onChange={field.onChange}
                                                isInvalid={meta.touched && !!meta.error}
                                                maxLength={300}
                                            />
                                            <Form.Text className={styles.countDown}>
                                                {field.value.length}/<span className={styles.countDownBold}>300</span>
                                            </Form.Text>
                                            {meta.touched && meta.error && (
                                                <Form.Control.Feedback type="invalid">
                                                    {meta.error}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    )}
                                </Field>
                                <div className='d-flex flex-row-reverse'>
                                    <div className={styles.navigateBtnCol}>
                                        <CustomButton
                                            id="pipeline_name_confirm"
                                            buttonType="submit"
                                            label="Next"
                                            type="primaryBtn"
                                        />
                                    </div>
                                </div>
                            </Form>
                        </Col>
                    </Modal.Body>
                </Modal>
            )}
        </Formik>
    );
};

export default EditQuestionModalActiveTempalte;
